'use client';
import Link from 'next/link';
import React, { useMemo } from 'react';

import { usePathname } from 'next/navigation';
import { useAuthenticated, useLogin } from '@/store';

export interface SideNavItemProps {
	title: string;
	link?: string;
	onClick?: () => void | null;
	icon?: React.ReactNode;
	authRequired?: boolean;
}

const SideNavItem = ({
	title,
	link,
	icon,
	authRequired = false,
	onClick,
}: SideNavItemProps) => {
	const pathname = usePathname();
	const login = useLogin();
	const authenticated = useAuthenticated();

	const isActive = useMemo(() => {
		if (pathname === link) {
			return true;
		}

		return false;
	}, [link, pathname]);

	if (authRequired && !authenticated) {
		return (
			<button
				aria-label={title}
				className={`capitalize flex items-center  py-[5px] relative px-2.5  motion-safe:hover:text-electric-sky duration-200 ease-in-out 
				${isActive ? 'text-electric-sky' : ''}
		`}
				onClick={() => {
					try {
						login();
					} catch {}
				}}
			>
				{isActive ? (
					<span className=" w-1 h-[30px] rounded-t-[2px] rounded-b-[2px]  bg-electric-sky absolute -left-2.5 "></span>
				) : null}
				{icon ? (
					<div
						className={`w-5 h-5 relative flex  justify-center items-center    mr-5 ${isActive ? 'text-electric-sky' : 'text-dove-white-o-70'} group-hover:text-electric-sky
		
				 `}
					>
						{icon}
					</div>
				) : null}

				{title}
			</button>
		);
	}

	if (onClick) {
		return (
			<button
				onClick={() => {
					if (onClick) {
						onClick();
					}
					if (window.innerWidth < 768) {
						const elementId = 'sidenav';
						const element = document.getElementById(elementId);
						if (!element) return;

						element.classList.toggle('-translate-x-[100%]');
						element.classList.toggle('translate-x-0');
					}
				}}
				aria-label={title}
				className={`capitalize flex items-center  py-[5px] relative px-2.5  motion-safe:hover:text-electric-sky duration-200 ease-in-out group 
			${isActive ? 'text-electric-sky' : ''}
	`}
			>
				{icon ? (
					<span
						className={`w-5 h-5 relative flex  justify-center items-center    mr-5 ${isActive ? 'text-electric-sky' : 'text-dove-white-o-70'} group-hover:text-electric-sky
		
				 `}
					>
						{icon}
					</span>
				) : null}

				{title}
			</button>
		);
	}

	// check if https
	if (link.startsWith('http')) {
		return (
			<a
				href={link}
				target="_blank"
				rel="noopener noreferrer"
				className={`capitalize flex items-center  py-[5px] relative px-2.5  motion-safe:hover:text-electric-sky duration-200 ease-in-out group 
			${isActive ? 'text-electric-sky' : ''}
	`}
				onClick={() => {
					if (window.innerWidth < 768) {
						const elementId = 'sidenav';
						const element = document.getElementById(elementId);
						if (!element) return;

						element.classList.toggle('-translate-x-[100%]');
						element.classList.toggle('translate-x-0');
					}
				}}
			>
				{icon ? (
					<span
						className={`w-5 h-5 relative flex  justify-center items-center    mr-5 ${isActive ? 'text-electric-sky' : 'text-dove-white-o-70'} group-hover:text-electric-sky
		
				 `}
					>
						{icon}
					</span>
				) : null}

				{title}
			</a>
		);
	}

	return (
		<Link
			href={link}
			className={`capitalize flex items-center  py-[5px] relative px-2.5  motion-safe:hover:text-electric-sky duration-200 ease-in-out group 
						${isActive ? 'text-electric-sky' : ''}
				`}
			onClick={() => {
				if (window.innerWidth < 768) {
					const elementId = 'sidenav';
					const element = document.getElementById(elementId);
					if (!element) return;

					element.classList.toggle('-translate-x-[100%]');
					element.classList.toggle('translate-x-0');
				}
			}}
		>
			{isActive ? (
				<span className=" w-1 h-[30px] rounded-t-[2px] rounded-b-[2px]  bg-electric-sky absolute -left-2.5 "></span>
			) : null}
			{icon ? (
				<span
					className={`w-5 h-5 relative flex  justify-center items-center    mr-5 ${isActive ? 'text-electric-sky' : 'text-dove-white-o-70'} group-hover:text-electric-sky
		
				 `}
				>
					{icon}
				</span>
			) : null}

			{title}
		</Link>
	);
};

export default SideNavItem;
